export default class ReachPerformance {
  performance: number;

  constructor(performance: number) {
    this.performance = performance;
  }

  static from(data) {
    return new ReachPerformance(data.performance);
  }
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/metrics/domain/ReachPerformance.js